module.exports = __webpack_public_path__ + "static/media/catalogue_ua_finwhale_2023.132e02a0.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/static/docs/catalogue_ua_finwhale_2023.pdf
// module id = 728
// module chunks = 0